import * as Yup from 'yup'

export const offersScheme = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  description: Yup.string().required('Description is required'),
  discount: Yup.string().required('Discount is required'),
  subTitle: Yup.string().required('SubTitle is required'),
  startDate: Yup.string()
    .required('Please Enter Start Date')
    .test(
      'is-future-date',
      'Start date and time must be in the future',
      value => {
        return value && new Date(value) > new Date()
      }
    ),

  endDate: Yup.string()
    .required('Please Enter End Date')
    .test(
      'is-after-start',
      'End date cannot be before start date',
      function (value) {
        const { startDate } = this.parent
        return value && startDate && new Date(value) > new Date(startDate)
      }
    ),
  locationId: Yup.string().required('Location is required')
})
